import http from '@/biz/http.mjs'

export default {
    readList: args => http.get('/dmbds/rules', {ruleTypes: ['INF'], ...args}),
}
